var Utils = {}

Utils.install = function (Vue) {
  var service = {
    // Get a value between two values
    clamp: function (value, min, max) {
      if (value < min) {
        return min
      } else if (value > max) {
        return max
      }

      return value
    },
    // Get the linear interpolation between two value
    lerp: function (value1, value2, amount) {
      amount = amount < 0 ? 0 : amount
      amount = amount > 1 ? 1 : amount
      return value1 + (value2 - value1) * amount
    },
    getCoords: function (elem) { // crossbrowser version
      if (!elem) {
        return null
      }

      var box = elem.getBoundingClientRect()

      var body = document.body
      var docEl = document.documentElement

      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

      var clientTop = docEl.clientTop || body.clientTop || 0
      var clientLeft = docEl.clientLeft || body.clientLeft || 0

      var top = box.top + scrollTop - clientTop
      var left = box.left + scrollLeft - clientLeft

      return {
        top: Math.round(top),
        left: Math.round(left),
        scrollTop: scrollTop,
        clientTop: clientTop
      }
    }

  }

  Vue.$utils = service
}

export default Utils



// WEBPACK FOOTER //
// ./src/plugins/Utils.js